module.exports = __webpack_public_path__ + "znamenka-a-kozni-vyrustky_4_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/znamenka-a-kozni-vyrustky_4_before.jpg
// module id = 1012
// module chunks = 0